"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Web3 = require('web3');

var getRPC = require('../rpc');

var error = require('../../constant/error');

var Queryc =
/**
 * 
 * @param {*} net - network ID or net work name
 */
function Queryc(net) {
  _classCallCheck(this, Queryc);

  var rpc = getRPC(net);
  if (!rpc) throw new Error(error.CANNOT_CONNECT_RPC);
  this.RPC = rpc;
  var providerEngine = new Web3.providers.HttpProvider(this.RPC);
  this.web3 = new Web3(providerEngine);
};

module.exports = Queryc;